import styled from "@emotion/styled"
import { Drawer, Grid, IconButton, Typography } from "@mui/material"

export const Wrapper = styled(Drawer)`
  .MuiDrawer-paper {
    height: 100%;
    padding: 1em;
    background-color: white;
    width: 100%;
    ${({ theme }) => theme.breakpoints.up("md")} {
      width: 480px;
    }
    ${({ theme }) => theme.breakpoints.down("md")} {
      padding: 2em;
    }
  }
`

export const InnerWrapper = styled.div`
  //flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  color: white;
  padding-bottom: 2.5rem;
  height: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 2.5rem 1.5rem;
  }
`
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  //margin-bottom: 6.5em;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LogoContainerMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  //margin-bottom: 6.5em;
`

export const CloseButton = styled(IconButton)`
  //position: absolute;
  //top: 1.5rem;
  //right: 2rem;

  // ${({ theme }) => theme.breakpoints.down("md")} {
  //   //position: relative;
  //   width: 30px;
  //   padding: 0;
  //   height: auto;
  //   right: 0;
  //   top: -0.3rem;
  // }
  svg {
    &:hover {
      transition: 0.3s ease-in-out;
      transform: scale(1.2);
    }
    ${({ theme }) => theme.breakpoints.down("md")} {
      width: 35px;
      height: 35px;
    }
  }
`

export const Title = styled.h3`
  color: ${({ theme }) => theme.palette.primary.main};
  font-style: normal;
  font-weight: 500;
  font-size: 2rem;
  line-height: 42px;
  /* identical to box height, or 131% */
  letter-spacing: -0.005em;
`

export const Description = styled(Typography)`
  margin-top: 2.5rem;
  color: #3a3a3a;
  padding-bottom: 1rem;
`

export const InfoGrid = styled(Grid)`
  padding-top: 2em;
  padding-bottom: 3em;
`

export const InfoCol = styled(Grid)`
  span {
    display: block;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    margin-bottom: 0.5em;
  }
  p,
  a {
    display: block;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    line-height: ${({ theme }) => theme.typography.pxToRem(52)};
    text-decoration: none;
    color: ${({ theme }) => theme.palette.secondary.main};
    letter-spacing: 0;
    ${({ theme }) => theme.breakpoints.down("md")} {
      font-size: ${({ theme }) => theme.typography.pxToRem(18)};
      line-height: ${({ theme }) => theme.typography.pxToRem(40)};
    }
  }
`
export const FormGrid = styled(Grid)`
  margin-top: 4em;
  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: 1em;
  }
`
export const InfoForm = styled.span`
  display: block;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  margin-bottom: 0.5em;
`
export const InfoContainer = styled.div`
  display: flex;
  column-gap: 2em;
  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
  }
`
export const Content = styled.div``

export const SuccessMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  padding: 1em;

  a {
    color: black;
  }

  p {
    color: black;
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
    ${({ theme }) => theme.breakpoints.up("md")} {
      font-size: 2rem;
    }
  }
`
export const SmallText = styled(Typography)`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #5f5f5f;
`
